import { useStores } from '.';
import { RouterStore } from 'mobx-react-router';

export function useRouterStore(): RouterStore {
  const { router } = useStores();
  return router as RouterStore;
}
